import { Component, HostListener, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { HeaderComponent } from "./components/shared/header/header.component";
import { RolePermissionsService } from './services/role-permissions.service';
import { MsalService } from "@azure/msal-angular";
import { LoaderComponent } from './components/loader/loader.component';
import { Subject, take, takeUntil } from "rxjs";
import { FilterService } from "./services/retainFilterControlState.service";
import { AccountInfo } from "@azure/msal-browser";
import { RoleService } from "./services/role.service";
@Component({
  standalone: true,
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  msalInitialized = false;
  userRoles = signal<string[]>([]);
  activeAccount = signal<AccountInfo | null>(null);
  public roleService = inject(RoleService);
  private destroy$ = new Subject<void>();

  constructor(
    private rolePermissionsService: RolePermissionsService,
    private msalService: MsalService,
    private filterService: FilterService
  ) { }

  @HostListener('window:beforeunload', ['$event'])
  clearFiltersOnReload(event: BeforeUnloadEvent) {
    // Call a clear method in your FilterService
    this.filterService.clearAll();
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.msalService.instance.initialize();
      this.msalInitialized = true;
      console.log('MSAL initialized successfully', this.msalService.instance.getAllAccounts());
      
      // Instead, subscribe to RoleService which HeaderComponent will populate
      // once MSAL finishes its inProgress$ flow.
      this.roleService.roles$
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe(roles => {
          let rolesString = roles.join(',') || 'NoRole';
          console.log('Roles received in AppComponent:', roles);

          this.rolePermissionsService.getRolePermissions(rolesString)
            .pipe(take(1))
            .subscribe({
              next: (data) => console.log('Permissions loaded:', data),
              error: (err) => console.error('Failed to load permissions:', err)
            });
        });
    } catch (error) {
      console.error('MSAL initialization failed:', error);
    }
  }

  extractRolesFromToken(account: AccountInfo): void {
    const claims = account.idTokenClaims as any;
    if (claims && claims.roles) {
      const roles = Array.isArray(claims.roles) ? claims.roles : [claims.roles];
      this.userRoles.set(roles);
      this.roleService.setRoles(roles); // Update roles in RoleService
      console.log('Roles found in ID Token:', roles);
    } else {
      //this.userRoles.set(['GSU']); // Set default role if not found
      //this.roleService.setRoles(['GSU']); // Update RoleService with default role
      console.warn('No roles claim found in the token. Ensure App Roles are defined in Azure Portal.');
    }
  }

  

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
